import pluginPkg from '../../package.json';
import pluginId from './pluginId';
import Initializer from './components/Initializer';
import { SkillsPluginIcon } from './components/PluginIcon';
import { createAxiosClient } from '#shared/api/axiosClient';

const name: string = pluginPkg.strapi.name;

export default {
  register(app: any) {
    createAxiosClient(strapi);
    app.addMenuLink({
      to: `/plugins/${pluginId}`,
      icon: SkillsPluginIcon,
      intlLabel: {
        id: `${pluginId}.plugin.name`,
        defaultMessage: name,
      },
      Component: async () => {
        const component = await import(
          /* webpackChunkName: "[request]" */ './pages/App'
        );
        return component;
      },
      permissions: [],
    });
    app.registerPlugin({
      id: pluginId,
      initializer: Initializer,
      isReady: false,
      name,
    });
  },

  bootstrap() {},
};
